module.exports = new __parcel__URL__("tailwind.cbf50016.png").toString();